if (!customElements.get("bundle-selector")) {
  customElements.define(
    "bundle-selector",
    class BundleSelector extends HTMLElement {
      connectedCallback() {
        this.form = this.closest("form");
        this.variantInput = this.form?.querySelector('input[name="id"]');
        this.quantityInput = this.form?.querySelector('input[name="quantity"]');
        this.submitPrice = this.form?.querySelector("[data-product-submit-price]");
        this.submitButton = this.form?.querySelector('[type="submit"][name="add"]');
        this.submitLabel = this.form?.querySelector("[data-product-submit-label]");
        this.unitPrice = this.querySelector("[data-bundle-unit-price]");
        this.options = Array.from(
          this.querySelectorAll('.bundle-selector__input[type="radio"]')
        );
        this.giftMessages = Array.from(
          this.querySelectorAll("[data-bundle-gift]")
        );

        if (!this.form || !this.variantInput || this.options.length === 0) return;

        this.options.forEach((option) => {
          option.addEventListener("change", () => this.select(option));
        });

        const initialOption = this.options.find((option) => option.checked);
        if (initialOption) this.select(initialOption);
      }

      select(option) {
        if (!option.checked) return;

        this.variantInput.value = option.dataset.variantId;
        this.variantInput.disabled = false;
        this.variantInput.dispatchEvent(new Event("change", { bubbles: true }));

        if (this.quantityInput) this.quantityInput.value = "1";
        if (this.submitPrice) this.submitPrice.textContent = option.dataset.price;
        if (this.unitPrice) this.unitPrice.textContent = option.dataset.unitPrice;

        const isAvailable = option.dataset.available === "true";
        if (this.submitButton) {
          this.submitButton.disabled = !isAvailable;
          this.submitButton.toggleAttribute("aria-disabled", !isAvailable);
        }
        if (this.submitLabel) {
          this.submitLabel.textContent = isAvailable
            ? this.dataset.addLabel
            : this.dataset.soldOutLabel;
        }

        this.giftMessages.forEach((message) => {
          message.hidden = message.dataset.bundleGift !== option.value;
        });
      }
    }
  );
}
